import script from "./AgreementsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AgreementsPage.vue?vue&type=script&setup=true&lang=js"

import "./AgreementsPage.vue?vue&type=style&index=0&id=48653b54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48653b54"]])

export default __exports__